<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul
      v-if="state.errMsg"
      style="
        font-weight: 600;
        text-align: center;
        font-size: 30px;
        color: #a2a2a2;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <el-image :src="require('@/assets/images/nodata.png')" />
    </ul>
    <template v-else>
      <ul
        class="form-box"
        style="gap: 10px; display: flex; flex-direction: column"
      >
        <div
          v-for="item in state.list"
          :key="item"
          style="background-color: #f6f6f6; padding: 10px"
        >
          <ul style="font-weight: 600; font-size: 13px">
            基本信息
          </ul>
          <div
            style="
              padding: 10px;
              display: grid;
              grid-template-columns: 1fr 1fr 1fr;
              row-gap: 10px;
            "
          >
            <li>
              <text>扣缴义务人：</text>
              <text>{{ item.withholding_agent_name }}</text>
            </li>
            <li>
              <text>所属税局：</text>
              <text>{{ item.tax_bureau_name }}</text>
            </li>
            <li style="display: flex; align-items: center">
              <text>应补(退)缴金额：</text>
              <c_money
                :value="parseFloat(item.ybtse)"
                style="color: #1e90ff"
                :size="20"
              ></c_money>
            </li>
            <li style="display: flex; align-items: center">
              <text>滞纳金：</text>
              <c_money
                :value="parseFloat(item.znje)"
                style="color: #ffa500"
                :size="20"
              ></c_money>
            </li>
            <li style="display: flex; align-items: center">
              <text>实际缴款金额：</text>
              <c_money
                :value="parseFloat(item.pay_money)"
                style="color: #080; font-weight: 600"
                :size="20"
              ></c_money>
            </li>
          </div>
          <ul style="font-weight: 600; font-size: 13px; margin-top: 10px">
            三方协议列表
          </ul>
          <el-radio-group
            v-model="item.sfxyh"
            style="display: block; font-size: 100%"
          >
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                border: 1px solid #e2e2e2;
                margin-top: 10px;
                text-align: center;
              "
              cellpadding="10"
              border="1"
            >
              <thead>
                <tr>
                  <th style="width: 100px">选择</th>
                  <th>三方协议号</th>
                  <th>开户银行</th>
                  <th>账户名称</th>
                  <th>缴款账户</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sfxy in item.sfxylb" :key="sfxy">
                  <td><el-radio :value="sfxy.sfxyh"></el-radio></td>
                  <td>{{ sfxy.sfxyh }}</td>
                  <td>{{ sfxy.yhhbmc }}</td>
                  <td>{{ sfxy.jkmc }}</td>
                  <td>{{ sfxy.jkzh }}</td>
                </tr>
              </tbody>
            </table>
          </el-radio-group>
        </div>
      </ul>
      <ul class="submit-box">
        <el-button type="primary" @click="onSubmit" :disabled="state.errMsg"
          >提交缴款</el-button
        >
      </ul>
    </template>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { taxpay_gettripleagreement, taxpay_pay } from "@/http/taxpay";
import { ElMessage } from "element-plus";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    ids: String,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      taxpay_gettripleagreement(props.ids)
        .then((res) => {
          if (res.status == 200) {
            state.list = res.data.data;
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            state.errMsg = err.data?.msg;
            ElMessage.error(err.data?.msg);
          }
        });
    });

    const onSubmit = () => {
      let judge = true;
      state.list.forEach((e) => {
        if (!e.sfxyh && judge) {
          ElMessage({
            message: `请指定<strong style='color:#f00'>${e.withholding_agent_name}<strong>的三方协议`,
            type: "warning",
            dangerouslyUseHTMLString: true,
            grouping: true,
          });
          judge = false;
          return false;
        }
      });
      if (judge) {
        const data = {
          pay_type: 1,
          id: state.list.map((m) => m.id).join(","),
          sfxyh: state.list.map((m) => m.sfxyh).join(","),
        };
        taxpay_pay(data).then((res) => {
          if (res.status == 200) {
            post_response(res, emit);
          }
        });
      }
    };
    return { state, onSubmit };
  },
};
</script>
<style scoped></style>
